import { render } from "./form-header-tc-note.html?vue&type=template&id=58a62dba&scoped=true&ts=true&external"
import script from "./form-header-tc-note.ts?vue&type=script&lang=ts&external"
export * from "./form-header-tc-note.ts?vue&type=script&lang=ts&external"

import "./form-header-tc-note.scss?vue&type=style&index=0&id=58a62dba&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a62dba"]])

export default __exports__